// extracted by mini-css-extract-plugin
module.exports = {"displayerContainer":"Displayer_displayerContainer__2HUtG","displayerImg":"Displayer_displayerImg__2cyy_","displyerInformation":"Displayer_displyerInformation__3fPO-"};